export const LENDERS_ALWAYS_VISIBLE = [
  {
    letter: "A",
    items: [
      "Admiral", "Advantage Finance Limited", "ALD Automotive UK",
      "Alphera Financial Services (BMW)", "Arkel Finance Ltd t/a Evington",
      "Audi Finance (Volkswagen)", "Automoney",
    ],
  },
  {
    letter: "B",
    items: [
      "Bank of Scotland", "Bank of Scotland t/a Capital Bank", "Barclays Partner Finance",
      "Bentley Financial Services (Volkswagen)", "Billing Finance Ltd", "Black Horse",
      "Blue Motor Finance Ltd", "BMW Financial Services (GB) Limited", "Borderway Finance Ltd",
    ],
  },
];

export const LENDERS_EXPANDABLE = [
  {
    letter: "C",
    items: [
      "CA Auto Finance UK Ltd", "Carcashpoint", "Citroen Finance (PSA Finance UK)",
      "Close Brothers Motor Finance", "Clydesdale Financial Services Ltd", "Creation Financial Services",
    ],
  },
  { letter: "D", items: ["Dacia Financial Services"] },
  {
    letter: "F",
    items: [
      "FCA Automotive Services Ltd (Fiat/Chrysler)",
      "FCA Automotive Services UK t/a FGA Capital UK Ltd",
      "FCE Bank PLC (Ford Credit)", "Ferrari Financial Services",
      "Fiat Financial Services", "First Response Finance",
    ],
  },
  { letter: "G", items: ["GMAC UK PLC", "Guardian Finance Limited"] },
  {
    letter: "H",
    items: [
      "Halifax", "Hitachi Capital (UK) PLC", "Honda Finance Europe PLC", "Hyundai Capital UK Limited",
    ],
  },
  { letter: "J", items: ["Jaguar Financial Services (Black Horse)", "Jeep Financial Services"] },
  { letter: "K", items: ["Kia Finance"] },
  {
    letter: "L",
    items: [
      "Land Rover Financial Services (Black Horse)", "Lendable Ltd",
      "Lexus Financial Services", "Lloyds",
      "Lombard Asset Finance Group", "Lombard Vehicle Solutions",
    ],
  },
  {
    letter: "M",
    items: [
      "Mallard Finance", "Marsh Finance", "Mazda Financial Services",
      "Mercedes-Benz Financial Services UK Limited", "MG Motor Financial Services",
      "Mi Vehicle Finance Ltd", "Mini Financial Services (BMW Financial Services (GB) Limited)",
      "Mitsubishi HC Capital UK PLC", "Moneybarn Ltd", "Moneyway",
      "Moneyway Motor Finance", "Motonovo Finance",
    ],
  },
  { letter: "N", items: ["Nissan Financial Services", "Northridge Finance", "Novuna Personal Finance"] },
  { letter: "O", items: ["Oasis Motor Finance", "Oodle Financial Services Ltd", "Oplo"] },
  {
    letter: "P",
    items: [
      "Paragon Motor Finance", "Peugeot Financial Services",
      "Porsche Financial Services (Volkswagen)", "Premium Plan Ltd", "PSA Finance UK Limited",
    ],
  },
  { letter: "R", items: ["Ratesetter", "RCI Financial Services", "Renault Financial Services"] },
  {
    letter: "S",
    items: [
      "Santander Consumer Finance (Car Finance)",
      "Santander Consumer Finance (Car Finance) t/a GE Capital Motor Finance Ltd",
      "Seat Financial Services (Volkswagen)", "Secure Trust Bank (Moneyway)",
      "Shogun Finance Ltd", "Skoda Finance (Volkswagen)", "Specialist Motor Finance Ltd",
      "Startline Motor Finance Limited", "Stellantis Financial Services",
      "Stoneacre Financial Services", "Suzuki Financial Services Ltd",
    ],
  },
  { letter: "T", items: ["Tandem Motor Finance t/a The 1st Stop Group", "Toyota Financial Services (UK) PLC"] },
  { letter: "U", items: ["United Trust Bank"] },
  {
    letter: "V",
    items: [
      "V12 Vehicle Finance", "Vauxhall Finance PLC",
      "Volkswagen Financial Services (UK) Limited", "Volvo Car Financial Services",
    ],
  },
  { letter: "W", items: ["Wye Finance Co Ltd"] },
  { letter: "Z", items: ["Zopa Bank Ltd"] },
];
